/**
 * FormCheckbox
 * ------------------------------------------------------------------------------
 * This field decorates input number fields with a plus and minus button.
 * Might be able to handle this with CSS
 *
   * @namespace custom
 */
custom.productCardHover = (() => {

	const hoverClassName = "js-product-card-hover";
	const hoverClass = 'product-card--has-hover';
	const noHoverClass = 'product-card--no-hover-image';
	const fetchedIdClass = 'product-card--shopify-id-fetched';

	let shopifyIds = [];

	/**
	 * getShopifyIdsToFetchImage
	 * Push all product ID to an array for API call
	 */
	function getShopifyIdsToFetchImage() {
		shopifyIds = []; // Empty Array
		const $productCards = $('.product-card').not('.' + fetchedIdClass);

		$productCards.each((index, card) => {
			const $el = $(card);

			if (!$el.hasClass(fetchedIdClass)) {
				shopifyIds.push($el.data('shopify-id'));
				$el.addClass(fetchedIdClass);
			}
		});
	}

	/**
	 * hoverInteractionHandler
	 * @params {object} imgs - an array of image src string
	 * Inject hover image src when it exists,
	 * Add no-hover class when it does not.
	 */
	function hoverInteractionHandler(imgs=[]) {
		for (let id in imgs) {
			const $el = $('.product-card[data-shopify-id="' + id + '"]');
			let imgSrc = imgs[id];

			if (imgSrc != '') {
        //need larger image for wall art
        if ($el.hasClass("js-product-card-pillow")) {
          imgSrc = imgSrc.replace('_300x.jpg', '_500x.jpg');
        }
				$el.find('.product-image--hover').attr('src', imgSrc);
				$el.addClass(hoverClass);
			} else {
				$el.addClass(noHoverClass);
			}
		}
	}

	function init() {
		if (!$(`.${hoverClassName}`).length) return;

    getShopifyIdsToFetchImage();
    if (!shopifyIds.length) return;
		custom.shopifyApi.getHoverImages(shopifyIds).done(imgs => {
			hoverInteractionHandler(imgs);
		});
	}

	return {
		init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/product-card-hover.js